module.exports = __webpack_public_path__ + "img/language.8d9d5c6b.svg";